// // src/pages/HRMSSoftware.js
// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
 
// /* ------------------- CONTACT FORM ------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     countrycode: "",
//     phone: "",
//     location: "",
//     no_of_employees: "",
//     no_of_branches: "",
//     product_taking_time: "",
//   });

//   const [submitting, setSubmitting] = useState(false);
//  const [status, setStatus] = useState(null); // ✅ must be null initially


//   const handleChange = (e) =>
//     setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSubmit = (e) => {
//   e.preventDefault();
//   setSubmitting(true);
//   setStatus(null); // clear old message

//   setTimeout(() => {
//     setSubmitting(false);
//     setStatus({
//       type: "success",
//       msg: "Thank you! We will contact you soon.",
//     });

//     setForm({
//       name: "",
//       email: "",
//       countrycode: "",
//       phone: "",
//       location: "",
//       no_of_employees: "",
//       no_of_branches: "",
//       product_taking_time: "",
//     });
//   }, 1200);
// };


//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="space-y-8 max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-lg"
//     >
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//           placeholder="Full Name"
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//           placeholder="Email Address"
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//           placeholder="Country Code"
//           name="countrycode"
//           value={form.countrycode}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//           placeholder="Phone Number"
//           name="phone"
//           value={form.phone}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
//           placeholder="Location"
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
//           placeholder="No. of Employees"
//           name="no_of_employees"
//           value={form.no_of_employees}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
//           placeholder="No. of Branches"
//           name="no_of_branches"
//           value={form.no_of_branches}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
//           placeholder="When do you plan to start?"
//           name="product_taking_time"
//           value={form.product_taking_time}
//           onChange={handleChange}
//           required
//         />
//       </div>

//       <button
//         className="w-full py-3 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition disabled:opacity-60"
//         disabled={submitting}
//       >
//         {submitting ? "Submitting..." : "Request Demo"}
//       </button>

//      {status?.type === "success" && (
//   <p className="text-center text-green-600 font-medium mt-4">
//     {status.msg}
//   </p>
// )}

//     </form>
//   );
// };

 
 
// /* ------------------- MAIN PAGE ------------------- */
// const HRMSSoftware = () => {
//   return (
//     <>
//       <Helmet>
//         <title>HRMS Software | Human Resource Management System</title>
//         <meta
//           name="description"
//           content="Full-featured HRMS platform for payroll, attendance, onboarding, and performance."
//         />
//       </Helmet>
//       <Navbar />
 
 
//       {/* -------------------------------- HERO SECTION -------------------------------- */}
//       <section className="relative bg-white pt-24 pb-32 overflow-hidden mt-[-90px]">
//         <img
//               src="/img/73.png"
//             alt="Logo"
//             className="w-32 mb-[-72px] ml-24"
//           />
//         {/* Background Shapes */}
//         {/* <img
//           src="/img/hero-bg1.png"
//           alt="decorative shape"
//           className="absolute top-15 left-[-180px] md:w-[480px] lg:w-[520px] opacity-90 pointer-events-none select-none"
//         />
//         <img
//           src="/img/hero-bg2.png"
//           alt="decorative shape"
//           className="absolute bottom-0 right-0 w-[420px] md:w-[520px] lg:w-[580px] opacity-90 pointer-events-none select-none"
//         /> */}
//         <div className="max-w-7xl mx-auto px-6 relative z-10">
//           <h1 className="text-center text-4xl lg:text-5xl font-extrabold text-gray-900">
//             Human Resource Management System <br />
//             for Today’s Modern Workplaces
//           </h1>
//           <p className="text-center mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
//             A modern Human Resource Management System designed to streamline
//             recruitment, attendance, payroll and employee records, delivering
//             secure, seamless and fully automated HR operations for today’s
//             workplaces.
//           </p>
//           <div className="mt-8 flex justify-center">
//             {/* <button className="bg-purple-600 hover:bg-purple-700 text-white px-10 py-3 rounded-full font-semibold shadow-lg transition">
//               View Website
//             </button> */}
//           </div>
//           <div className="mt-16 flex justify-center">
//             <div className="rounded-3xl overflow-hidden shadow-2xl w-full max-w-4xl">
//               <video
//                 src="/video/Shrava 360.mp4"
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//                 preload="auto"
//                 className="w-full h-full object-cover cursor-pointer"
//                 onClick={(e) => {
//                   const vid = e.currentTarget;
//                   vid.paused ? vid.play() : vid.pause();
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </section>
 
//       {/* -------------------------------- BENEFITS SECTION (UPDATED) -------------------------------- */}
//       <section
//         className="relative bg-[#0f0d1f] py-24 text-white overflow-hidden"
//         style={{
//           backgroundImage: "url('/img/pipes.png')",
//           backgroundSize: "cover",
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 px-6 relative z-10">
//           {/* Left Image */}
//           <div className="relative">
//             <img
//               src="/img/hrms2.png"
//               className="rounded-xl shadow-2xl"
//               alt="HRMS Dashboard"
//             />
//             <img
//               src="/img/hrms1.png"
//               className="absolute -top-6 -left-6 rounded-xl shadow-xl"
//               alt="Preview"
//             />
//           </div>
 
//           {/* Right Text Content - NEW CONTENT */}
//           <div className="">
//             <h2 className="text-4xl font-extrabold mb-6">
//               Benefits of a Human Resource Management System
//             </h2>
//             <p className="text-xl text-gray-300 mb-12">
//               Streamline HR, empower employees and drive organisational success
//             </p>
 
//             <div className="space-y-10">
//               {/* Hiring & Onboarding */}
//               <div className="flex gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
//                   1
//                 </div>
//                 <div>
//                   <h3 className="text-2xl font-semibold mb-2">
//                     Hiring & Onboarding
//                   </h3>
//                   <p className="text-gray-400">
//                     Automate recruitment and onboarding to ensure faster and
//                     smoother employee integration
//                   </p>
//                 </div>
//               </div>
 
//               {/* Attendance & Leave */}
//               <div className="flex gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
//                   2
//                 </div>
//                 <div>
//                   <h3 className="text-2xl font-semibold mb-2">
//                     Attendance & Leave
//                   </h3>
//                   <p className="text-gray-400">
//                     Track attendance and leave requests to reduce daily
//                     administrative workload efficiently
//                   </p>
//                 </div>
//               </div>
 
//               {/* Payroll & Compensation */}
//               <div className="flex gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
//                   3
//                 </div>
//                 <div>
//                   <h3 className="text-2xl font-semibold mb-2">
//                     Payroll & Compensation
//                   </h3>
//                   <p className="text-gray-400">
//                     Process salaries, bonuses, and taxes accurately for timely
//                     employee payments always
//                   </p>
//                 </div>
//               </div>
 
//               {/* Employee Data & Performance */}
//               <div className="flex gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
//                   4.
//                 </div>
//                 <div>
//                   <h3 className="text-2xl font-semibold mb-2">
//                     Employee Data & Performance
//                   </h3>
//                   <p className="text-gray-400">
//                     Manage records securely and monitor employee performance to
//                     support consistent growth
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
 
//       {/* -------------------------------- FEATURES SECTION – ACCORDION WITH ICON -------------------------------- */}
//       <section className="relative bg-white pt-24 pb-40 overflow-hidden">
//         <img
//           src="/img/waves.png"
//           alt="wave"
//           className="absolute bottom-0 left-0 w-full pointer-events-none select-none"
//         />
 
//         <div className="max-w-7xl mx-auto px-6 relative z-10">
//           {/* HEADING */}
//           <div className="text-center mb-20">
//             <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
//               Complete HRMS Features for Efficient HR Operations
//             </h2>
//             <p className="mt-6 text-xl md:text-2xl text-gray-700 font-medium max-w-5xl mx-auto">
//               A modular and advanced HRMS platform designed to streamline
//               recruitment, attendance, payroll and employee records, delivering
//               secure, seamless and fully automated HR operations across your
//               organization.
//             </p>
//           </div>
 
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
//             {/* LEFT: ACCORDION WITH ICON */}
//             <div className="space-y-6">
//               {/* Feature 1 */}
//               <details className="group">
//                 <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
//                   <span className="text-2xl lg:text-1xl font-bold text-gray-800">
//                     Employee Login & Attendance Tracking
//                   </span>
//                   <svg
//                     className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M19 9l-7 7-7-7"
//                     />
//                   </svg>
//                 </summary>
//                 <div className="px-8 pb-8 pt-4">
//                   <p className="text-lg text-gray-600 leading-relaxed">
//                     Secure login, role-based access, punch-in/out and
//                     auto-alerts ensures accurate attendance and workforce
//                     discipline.
//                   </p>
//                 </div>
//               </details>
 
//               {/* Feature 2 */}
//               <details className="group">
//                 <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
//                   <span className="text-2xl lg:text-1xl font-bold text-gray-800">
//                     Automated Payslips & Employee Profiles
//                   </span>
//                   <svg
//                     className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M19 9l-7 7-7-7"
//                     />
//                   </svg>
//                 </summary>
//                 <div className="px-8 pb-8 pt-4">
//                   <p className="text-lg text-gray-600 leading-relaxed">
//                     Auto-generated salary slips, bonuses, tax deductions and
//                     centralised records saves HR time and reduces errors.
//                   </p>
//                 </div>
//               </details>
 
//               {/* Feature 3 */}
//               <details className="group">
//                 <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
//                   <span className="text-2xl lg:text-1xl font-bold text-gray-800">
//                     Recruitment & Onboarding
//                   </span>
//                   <svg
//                     className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M19 9l-7 7-7-7"
//                     />
//                   </svg>
//                 </summary>
//                 <div className="px-8 pb-8 pt-4">
//                   <p className="text-lg text-gray-600 leading-relaxed">
//                     Job posting, candidate screening, automated offer letters
//                     and onboarding checklists ensures a smooth hiring process.
//                   </p>
//                 </div>
//               </details>
//             </div>
 
//             {/* RIGHT: IMAGES */}
//             <div className="relative w-full flex justify-center lg:justify-end">
//               <div className="absolute top-5 left-5 w-[85%] rounded-3xl overflow-hidden shadow-2xl opacity-90">
//                 <img
//                   src="/img/hrms3.png"
//                   className="w-full h-full object-cover"
//                   alt=""
//                 />
//               </div>
//               <div className="relative z-20 w-[90%] rounded-3xl overflow-hidden shadow-2xl">
//                 <img
//                   src="/img/hrms4.png"
//                   className="w-full h-full object-cover"
//                   alt=""
//                 />
//               </div>
//               <div className="absolute bottom-[-20px] right-0 w-40 h-40 rounded-2xl overflow-hidden shadow-xl z-30">
//                 <img
//                   src="/img/hrms5.jpg"
//                   className="w-full h-full object-cover"
//                   alt=""
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
 
//       {/* -------------------------------- CONTACT SECTION -------------------------------- */}
//       <section id="contact" className="py-24 bg-gray-50">
//         <div className="max-w-5xl mx-auto px-6 text-center">
//           <h2 className="text-4xl font-bold text-gray-800">Get In Touch</h2>
//           <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
//             Ready to automate your HR? Request a free product demo today.
//           </p>
//           <div className="mt-12 bg-white p-10 rounded-3xl shadow-xl">
//             <ContactForm />
//           </div>
//         </div>
//       </section>
 
//       <Footer />
 
//       {/* Scroll to Top */}
//       <button
//         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//         className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-purple-700 text-white rounded-full shadow-lg hover:bg-purple-800 transition flex items-center justify-center"
//       >
       
//       </button>
//     </>
//   );
// };
 
// export default HRMSSoftware;
 
 

// src/pages/HRMSSoftware.js
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

/* ------------------- CONTACT FORM ------------------- */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    countrycode: "",
    phone: "",
    location: "",
    no_of_employees: "",
    no_of_branches: "",
    product_taking_time: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Name validation - only letters and spaces
    if (name === "name") {
      const nameRegex = /^[a-zA-Z\s]*$/;
      if (!nameRegex.test(value)) return;
    }
    
    setForm({ ...form, [name]: value });
  };

  const validate = () => {
    if (!form.name?.trim()) return "Name is required";
    if (!form.email?.trim()) return "Email is required";
    
    // Email validation
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(form.email)) return "Enter a valid email address";
    
    if (!form.countrycode?.trim()) return "Country code is required";
    if (!form.phone?.trim()) return "Phone number is required";
    if (!form.location?.trim()) return "Location is required";
    if (!form.no_of_employees || isNaN(form.no_of_employees) || parseInt(form.no_of_employees) < 1) {
      return "Enter valid number of employees (minimum 1)";
    }
    if (!form.no_of_branches || isNaN(form.no_of_branches) || parseInt(form.no_of_branches) < 0) {
      return "Enter valid number of branches (minimum 0)";
    }
    if (!form.product_taking_time?.trim()) return "Please enter when you plan to start";
    
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) {
      alert(err);
      return;
    }

    setSubmitting(true);

    // Simulate API call
    setTimeout(() => {
      setSubmitting(false);
      setShowSuccessPopup(true);
      setForm({
        name: "",
        email: "",
        countrycode: "",
        phone: "",
        location: "",
        no_of_employees: "",
        no_of_branches: "",
        product_taking_time: "",
      });
    }, 1200);
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
  };

  useEffect(() => {
    if (showSuccessPopup) {
      const timer = setTimeout(() => {
        setShowSuccessPopup(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessPopup]);

  if (showSuccessPopup) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl relative">
          {/* Close Button */}
          <button
            onClick={closePopup}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl font-bold p-2 hover:bg-gray-100 rounded-full transition-all w-10 h-10 flex items-center justify-center"
          >
            ×
          </button>
          
          <div className="text-center pt-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Success!</h3>
            <p className="text-gray-700 mb-6">Thank you! We will contact you soon.</p>
            <p className="text-xs text-gray-500">You can request another demo now.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-8 max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-lg"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <input
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          placeholder="Full Name *"
          name="name"
          value={form.name}
          onChange={handleChange}
          maxLength={50}
          required
        />

        <input
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          placeholder="Email Address *"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          required
        />
<select
  name="countrycode"
  value={form.countrycode}
  onChange={handleChange}
  required
  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none bg-white"
>
  <option value="">Country Code *</option>
  <option value="+91">🇮🇳 +91 (India)</option>
  <option value="+1">🇺🇸 +1 (USA)</option>
  <option value="+44">🇬🇧 +44 (UK)</option>
  <option value="+61">🇦🇺 +61 (Australia)</option>
  <option value="+971">🇦🇪 +971 (UAE)</option>
</select>


        <input
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          placeholder="Phone Number *"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          required
        />

        <input
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
          placeholder="Location *"
          name="location"
          value={form.location}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          min="1"
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
          placeholder="No. of Employees *"
          name="no_of_employees"
          value={form.no_of_employees}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          min="0"
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
          placeholder="No. of Branches *"
          name="no_of_branches"
          value={form.no_of_branches}
          onChange={handleChange}
          required
        />

        <input
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:outline-none md:col-span-2"
          placeholder="When do you plan to start? *"
          name="product_taking_time"
          value={form.product_taking_time}
          onChange={handleChange}
          required
        />
      </div>

      <button
        className="w-full py-3 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition disabled:opacity-60"
        disabled={submitting}
      >
        {submitting ? "Submitting..." : "Request Demo"}
      </button>
    </form>
  );
};

/* ------------------- MAIN PAGE ------------------- */
const HRMSSoftware = () => {
  return (
    <>
      <Helmet>
        <title>HRMS Software | Human Resource Management System</title>
        <meta
          name="description"
          content="Full-featured HRMS platform for payroll, attendance, onboarding, and performance."
        />
      </Helmet>
      <Navbar />

      {/* -------------------------------- HERO SECTION -------------------------------- */}
     {/* <section className="relative bg-white pt-24 pb-32 overflow-hidden mt-[-90px]">
  <div className="max-w-7xl mx-auto px-6 relative z-10 flex flex-col text-center gap-10">

        <img
          src="/img/73.png"
          alt="Logo"
          className="w-32 mb-[-72px] ml-24"
        />
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <h1 className="text-center text-4xl lg:text-5xl font-extrabold text-gray-900">
            Human Resource Management System <br />
            for Today's Modern Workplaces
          </h1>
          <p className="text-center mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
            A modern Human Resource Management System designed to streamline
            recruitment, attendance, payroll and employee records, delivering
            secure, seamless and fully automated HR operations for today's
            workplaces.
          </p>
          <div className="mt-16 flex justify-center">
            <div className="rounded-3xl overflow-hidden shadow-2xl w-full max-w-4xl">
              <video
                src="/video/Shrava 360.mp4"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="w-full h-full object-cover cursor-pointer"
                onClick={(e) => {
                  const vid = e.currentTarget;
                  vid.paused ? vid.play() : vid.pause();
                }}
              />
            </div>
          </div>
        </div>
      
     </div> </section> */}

       <section className="relative w-full bg-[#2A4546]  px-6  mb-16">
        <div className="absolute top-0 right-0 w-[420px] h-[120px] bg-[#cae9ff] rounded-bl-full opacity-70 -z-10"></div>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Left Text */}
          <div>
            <img    src="/img/shravanew1.png" alt="Logo" className="w-20 mt-10 mb-6" />
            <p className="text-sm tracking-wide font-semibold text-white mb-2">
              Human Resource Management System 
            </p>

            <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-[38px]">
              {/* Human Resource Management System <br /> */}
            For Today's Modern Workplaces
            </h1>

            <p className="text-white mt-4 leading-relaxed mb-[128px]">
                A modern Human Resource Management System designed to streamline
            recruitment, attendance, payroll and employee records, delivering
            secure, seamless and fully automated HR operations for today's
            workplaces.
            </p>

            {/* <div className="flex gap-4 mt-6">
              <button className="px-6 py-3 bg-[#2c75ff] text-white rounded-lg font-semibold hover:bg-[#1d5bd9] transition">
                Book a Demo
              </button>
              <button className="px-6 py-3 border border-[#2c75ff] text-[#2c75ff] rounded-lg font-semibold hover:bg-[#2c75ff] hover:text-white transition">
                Contact Us
              </button>
            </div> */}
          </div>

          {/* Right Image */}
          <div className="mb-[-32px]">
            <img
              src="/img/hrmsnew.png"
              alt="Hospital Dashboard"
              className="w-full drop-shadow-lg "
            />
          </div>

          
        </div>
        
      </section>

        <section className="w-full py-4 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto mb-10 text-center">
            <h2 className="text-3xl font-bold text-[#063852]">
              HR Management Made Simple
            </h2>
            <p className="text-gray-600 mt-3">
             Explore how our HR Management System supports day-to-day HR tasks, reduces manual work, and keeps teams organised—helping modern workplaces manage people, processes, and productivity more efficiently.
            </p>
          </div>

          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
            <video
                src="/video/shravanew.mp4"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="w-full h-full object-cover cursor-pointer"
                onClick={(e) => {
                  const vid = e.currentTarget;
                  vid.paused ? vid.play() : vid.pause();
                }}
              />
          

            <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const video = e.currentTarget.closest("div").querySelector("video");
                  if (video.requestFullscreen) video.requestFullscreen();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
                title="Fullscreen"
              >
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* -------------------------------- BENEFITS SECTION -------------------------------- */}
      <section
        className="relative bg-[#0f0d1f] py-24 text-white overflow-hidden"
        style={{
          // backgroundImage: "url('/img/pipes.png')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 px-6 relative z-10">
          {/* Left Image */}
  {/* Left Image */}
<div className="flex flex-col gap-6">
  <img
    src="/img/hrms2.png"
    className="rounded-xl shadow-2xl"
    alt="HRMS Dashboard"
  />

  <img
    src="/img/hrms1.png"
    className="rounded-xl shadow-xl"
    alt="Preview"
  />
</div>


          {/* Right Text Content */}
          <div className="">
            <h2 className="text-4xl font-extrabold mb-6">
              Benefits of a Human Resource Management System
            </h2>
            <p className="text-xl text-gray-300 mb-12">
              Streamline HR, empower employees and drive organisational success
            </p>

            <div className="space-y-10">
              {/* Hiring & Onboarding */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Hiring & Onboarding
                  </h3>
                  <p className="text-gray-400">
                    Automate recruitment and onboarding to ensure faster and
                    smoother employee integration
                  </p>
                </div>
              </div>

              {/* Attendance & Leave */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  2
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Attendance & Leave
                  </h3>
                  <p className="text-gray-400">
                    Track attendance and leave requests to reduce daily
                    administrative workload efficiently
                  </p>
                </div>
              </div>

              {/* Payroll & Compensation */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  3
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Payroll & Compensation
                  </h3>
                  <p className="text-gray-400">
                    Process salaries, bonuses, and taxes accurately for timely
                    employee payments always
                  </p>
                </div>
              </div>

              {/* Employee Data & Performance */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  4.
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Employee Data & Performance
                  </h3>
                  <p className="text-gray-400">
                    Manage records securely and monitor employee performance to
                    support consistent growth
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* -------------------------------- FEATURES SECTION -------------------------------- */}
      <section className="relative bg-white pt-24 pb-40 overflow-hidden">
        <img
          src="/img/waves.png"
          alt="wave"
          className="absolute bottom-0 left-0 w-full pointer-events-none select-none"
        />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* HEADING */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
              Complete HRMS Features for Efficient HR Operations
            </h2>
            <p className="mt-6 text-xl md:text-2xl text-gray-700 font-medium max-w-5xl mx-auto">
              A modular and advanced HRMS platform designed to streamline
              recruitment, attendance, payroll and employee records, delivering
              secure, seamless and fully automated HR operations across your
              organization.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* LEFT: ACCORDION WITH ICON */}
            <div className="space-y-6">
              {/* Feature 1 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Employee Login & Attendance Tracking
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Secure login, role-based access, punch-in/out and
                    auto-alerts ensures accurate attendance and workforce
                    discipline.
                  </p>
                </div>
              </details>

              {/* Feature 2 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Automated Payslips & Employee Profiles
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Auto-generated salary slips, bonuses, tax deductions and
                    centralised records saves HR time and reduces errors.
                  </p>
                </div>
              </details>

              {/* Feature 3 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Recruitment & Onboarding
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Job posting, candidate screening, automated offer letters
                    and onboarding checklists ensures a smooth hiring process.
                  </p>
                </div>
              </details>
            </div>

            {/* RIGHT: IMAGES */}
            <div className="relative w-full flex justify-center lg:justify-end">
              <div className="absolute top-5 left-5 w-[85%] rounded-3xl overflow-hidden shadow-2xl opacity-90">
                <img
                  src="/img/hrms3.png"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div className="relative z-20 w-[90%] rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="/img/hrms4.png"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div className="absolute bottom-[-20px] right-0 w-40 h-40 rounded-2xl overflow-hidden shadow-xl z-30">
                <img
                  src="/img/hrms5.jpg"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* -------------------------------- CONTACT SECTION -------------------------------- */}
      <section id="contact" className="py-24 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-gray-800">Get In Touch</h2>
          <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
            Ready to automate your HR? Request a free product demo today.
          </p>
          <div className="mt-12 bg-white p-10 rounded-3xl shadow-xl">
            <ContactForm />
          </div>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top */}
      {/* <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-purple-700 text-white rounded-full shadow-lg hover:bg-purple-800 transition flex items-center justify-center"
      >
        
      </button> */}
    </>
  );
};

export default HRMSSoftware;
